import { render } from "./CloudMDPrivacyPolicyText.vue?vue&type=template&id=03985c5c&scoped=true"
import script from "./CloudMDPrivacyPolicyText.vue?vue&type=script&lang=js"
export * from "./CloudMDPrivacyPolicyText.vue?vue&type=script&lang=js"

import "./CloudMDPrivacyPolicyText.vue?vue&type=style&index=0&id=03985c5c&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03985c5c"]])

export default __exports__